import { GRADES } from 'app/types/grades.types'

export const KNOWLEDGE_BUILDER_COLORS = [
  '#006fe4',
  '#ff435f',
  '#03aa00',
  '#d03ac4',
  '#ca850c',
  '#39bfc5',
  '#e383b1',
  '#7687e9',
  '#ff662b',
  '#5ac5ff',
  '#df447c',
  '#7d51e8',
  '#2ada7d',
  '#bb60ea',
  '#238d99',
  '#4c6abb',
]

export const LIBRARY_COLORS = {
  defaultK: {
    background: '#f7e0ff',
  },
  defaultMS: {
    main: '#fff',
    border: '#208b9e',
    leftSide: '#32c2dc',
    background: 'linear-gradient(to bottom, #1a7b7d, #28517c)',
  },
  3: {
    main: '#fff',
    leftSide: '#57e4fd',
    border: '#197a8b',
    background: 'linear-gradient(to bottom, #32c2dc, #026ba6)',
  },
  4: {
    main: '#fff',
    leftSide: '#1aa9fa',
    border: '#035888',
    background: 'linear-gradient(to bottom, #026ba6 0%, #732775)',
  },
  5: {
    main: '#fff',
    leftSide: '#ca56fe',
    border: '#521953',
    background: 'linear-gradient(to bottom, #732775 0%, #240445)',
  },
}

export const SOUND_COLORS = [
  {
    tab: '#149cdb',
    page: '#e8f6ff',
  },
  {
    tab: '#ff435f',
    page: '#ffe8e8',
  },
  {
    tab: '#03aa00',
    page: '#e6ffe6',
  },
  {
    tab: '#d03ac4',
    page: '#ffdcfc',
  },
  {
    tab: '#ca850c',
    page: '#fff7e8',
  },
]

export const KINDERGARTEN_LIBRARY_COLORS = [
  {
    main: '#b8f3ec',
    border: '#6daaa3',
    leftSide: '#7be1d2',
    imageBorder: '#9fccc7',
  },
  {
    main: '#c0ffc0',
    border: '#50ac61',
    leftSide: '#9ee19e',
    imageBorder: '#db93a6',
  },
  {
    main: '#bdf5ff',
    border: '#3ba6c2',
    leftSide: '#47cde6',
    imageBorder: '#9fccc7',
  },
  {
    main: '#e9fefb',
    border: '#9fccc7',
    leftSide: '#bae8e2',
    imageBorder: '#acd2d0',
  },
]

export const GRADE_COLORS = {
  [GRADES.KINDERGARTEN]: '#e83f28',
  [GRADES.FIRST_GRADE]: '#f38d21',
  [GRADES.SECOND_GRADE]: '#a4ce39',
  [GRADES.THIRD_GRADE]: '#32c2dc',
  [GRADES.FOURTH_GRADE]: '#026ba6',
  [GRADES.FIFTH_GRADE]: '#732775',
}
export const MS_LIBRARY_IMAGE_BORDERS = ['#378251', '#bf5191', '#9263ab']

export const VOICEOVER_AUDIO_BUTTONS = {
  NO_AUDIO: {
    FILL: '#77879D',
    PROGRESS: '#77879D',
    HOVER: '#77879D',
  },
  PLAYER_NOT_CLICKED: {
    FILL: '#006FE4',
    PROGRESS: '#006FE4',
    HOVER: '#023b78',
  },
  PLAYING: {
    FILL: '#2A9700',
    PROGRESS: '#C0F18D',
    HOVER: '#028000',
  },
  PAUSE: {
    FILL: '#EE244B',
    PROGRESS: '#FFC8D0',
    HOVER: '#C63248',
  },
  REPLAY: {
    ACTIVE: '#006FE4',
    DISABLED: '#84A7AC',
    HOVER: '#023b78',
  },
}

export const EREADER_SELECTION_COLORS = [
  '#ffdca3',
  '#b7f0c5',
  '#fcb6e5',
  '#87dafa',
]
